import type { TooltipRenderProps } from 'react-joyride';
import { Button } from '@sorrem-client/ui/components';
import styles from './TourTooltip.module.scss';

/**
 * A guided tour's step, in the first-time callout's look (gold glow): its
 * title and text, then Skip tour, the step count, Back and Next. A dialog
 * that takes focus, so in a run the game holds its keys until it closes.
 */
export function TourTooltip({ index, size, isLastStep, step, backProps, primaryProps, skipProps, tooltipProps }: TooltipRenderProps): JSX.Element {
    return (
        <div {...tooltipProps} className={styles.tourTooltip} aria-labelledby='tour-step-title'>
            {step.title !== undefined && <h2 id='tour-step-title' className={styles.title}>{step.title}</h2>}
            <p className={styles.text}>{step.content}</p>
            <div className={styles.footer}>
                {!isLastStep && <Button {...skipProps} variant='link' size='small'>Skip tour</Button>}
                <span className={styles.count}>{`${index + 1} of ${size}`}</span>
                <div className={styles.buttons}>
                    {index > 0 && <Button {...backProps} variant='secondary' size='small'>Back</Button>}
                    {/* Focused on open, so the tooltip holds the keyboard (Enter goes on) and the game doesn't. */}
                    <Button {...primaryProps} variant='primary' size='small' autoFocus>{isLastStep ? 'Done' : 'Next'}</Button>
                </div>
            </div>
        </div>
    );
}
